"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainAdapterManager = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const unchained = __importStar(require("@shapeshiftoss/unchained-client"));
const bitcoin = __importStar(require("./bitcoin"));
const cosmos = __importStar(require("./cosmossdk/cosmos"));
const ethereum = __importStar(require("./ethereum"));
class ChainAdapterManager {
    constructor(unchainedUrls) {
        this.supported = new Map();
        this.instances = new Map();
        if (!unchainedUrls) {
            throw new Error('Blockchain urls required');
        }
        ;
        Object.entries(unchainedUrls).forEach(([type, { httpUrl, wsUrl }]) => {
            switch (type) {
                case types_1.ChainTypes.Ethereum: {
                    const http = new unchained.ethereum.V1Api(new unchained.ethereum.Configuration({ basePath: httpUrl }));
                    const ws = new unchained.ws.Client(wsUrl);
                    return this.addChain(type, () => new ethereum.ChainAdapter({ providers: { http, ws } }));
                }
                case types_1.ChainTypes.Bitcoin: {
                    const http = new unchained.bitcoin.V1Api(new unchained.bitcoin.Configuration({ basePath: httpUrl }));
                    const ws = new unchained.ws.Client(wsUrl);
                    return this.addChain(type, () => new bitcoin.ChainAdapter({ providers: { http, ws }, coinName: 'Bitcoin' }));
                }
                case types_1.ChainTypes.Cosmos: {
                    const http = new unchained.cosmos.V1Api(new unchained.cosmos.Configuration({ basePath: httpUrl }));
                    const ws = new unchained.ws.Client(wsUrl);
                    return this.addChain(type, () => new cosmos.ChainAdapter({ providers: { http, ws }, coinName: 'Cosmos' }));
                }
                default:
                    throw new Error(`ChainAdapterManager: cannot instantiate ${type} chain adapter`);
            }
        });
    }
    /**
     * Add support for a network by providing a class that implements ChainAdapter
     *
     * @example
     * import { ChainAdapterManager, UtxoChainAdapter } from 'chain-adapters'
     * const manager = new ChainAdapterManager(client)
     * manager.addChain('bitcoin', () => new UtxoChainAdapter('BTG', client))
     * @param {ChainTypes} chain - Coin/network symbol from Asset query
     * @param {Function} factory - A function that returns a ChainAdapter instance
     */
    addChain(chain, factory) {
        if (typeof chain !== 'string' || typeof factory !== 'function') {
            throw new Error('Parameter validation error');
        }
        this.supported.set(chain, factory);
    }
    removeChain(chain) {
        if (!Object.values(types_1.ChainTypes).includes(chain)) {
            throw new Error(`ChainAdapterManager: invalid chain ${chain}`);
        }
        if (!this.supported.has(chain)) {
            throw new Error(`ChainAdapterManager: chain ${chain} not registered`);
        }
        this.supported.delete(chain);
    }
    getSupportedChains() {
        return Array.from(this.supported.keys());
    }
    getSupportedAdapters() {
        return Array.from(this.supported.values());
    }
    /*** Get a ChainAdapter instance for a network */
    byChain(chain) {
        let adapter = this.instances.get(chain);
        if (!adapter) {
            const factory = this.supported.get(chain);
            if (factory) {
                adapter = factory();
                if (!adapter) {
                    throw new Error(`Adapter not available for [${chain}]`);
                }
                this.instances.set(chain, adapter);
            }
        }
        if (!adapter) {
            throw new Error(`Network [${chain}] is not supported`);
        }
        return adapter;
    }
    async byChainId(chainId) {
        // this function acts like a validation function and throws if the check doesn't pass
        (0, caip_1.isChainId)(chainId);
        for (const [chain] of this.supported) {
            // byChain calls the factory function so we need to call it to create the instances
            const adapter = this.byChain(chain);
            if ((await adapter.getChainId()) === chainId)
                return adapter;
        }
        throw new Error(`Chain [${chainId}] is not supported`);
    }
}
exports.ChainAdapterManager = ChainAdapterManager;
